export const getPortPosition=function ({ groupId, nodeId,port, portId}, el) {
    let deltaMatrix = el.transform().globalMatrix;
    if(!groupId || !nodeId || !portId || !port) return false;
    
    let group = el.select(`g[g-id='${groupId}'][f-type='group']`);

    //  let nodeDom = el.select(`[n-id='${nodeId}'][f-type='node']`)
    let portDom = group.select(`[n-port='${port}'][p-id='${portId}'][f-type='port']`)
    let globalMatrix = portDom.transform().globalMatrix;
    let scale = globalMatrix.a;
    let portX = (globalMatrix.e- deltaMatrix.e)/scale;
    let portY = (globalMatrix.f-deltaMatrix.f)/scale;
    let portCenterX = parseFloat(portDom.node.getAttribute("cx"));
    let portCenterY = parseFloat(portDom.node.getAttribute("cy"));
    
    return [portX   +portCenterX, portY  + portCenterY]

}




// WEBPACK FOOTER //
// ./src/assets/tflow/utils/dom.js